import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import React from 'react';
import { Route } from 'react-router';

export const routes$ = {
    List: AsyncPageRender(() => pageModule(import('./List'))),
    Edit: AsyncPageRender(() => pageModule(import('./Edit/Edit'))),
    EditSubcategory: AsyncPageRender(() => pageModule(import('./Subcategories/Edit'))),
};

function Router() {
    return (
        <>
            <Route
                exact
                path={'/operations/products/categories/:category/edit'}
                component={ProtectedRoute(routes$.Edit)}
            />
            <Route
                exact
                path={'/operations/products/categories/:category/edit/:tab'}
                component={ProtectedRoute(routes$.Edit)}
            />
            <Route
                exact
                path={'/operations/products/sub-categories/:category/edit'}
                component={ProtectedRoute(routes$.EditSubcategory)}
            />
        </>
    );
}

export default Router;
